import React, { useContext, useMemo } from 'react';
import { blackOrWhiteForeground } from '@utils/colors';
import { VisitableType } from '@enums/visitable-type-enum';
import { assigneeIcon } from '@utils/functions/assignee-functions';
import { CalendarContext } from '../CalendarContext';
function Visit(params) {
    var _a;
    const dynamicStyle = useMemo(() => {
        var _a, _b;
        return ({
            color: params.highlightStatus ? '#000' : blackOrWhiteForeground((_b = (_a = params.visit.assignee) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.color)
        });
    }, [params.visit, params.highlightStatus]);
    const { state: { detailed } } = useContext(CalendarContext);
    const typeIcon = useMemo(() => {
        var _a;
        switch ('visitableType' in params.visit ? (_a = params.visit) === null || _a === void 0 ? void 0 : _a.visitableType : params.visit.visitable.type) {
            case VisitableType.INSPECTION:
                return React.createElement("i", { className: "fa-light fa-clipboard-check" });
                break;
            case VisitableType.SERVICE:
                return React.createElement("i", { className: "fa-light fa-screwdriver-wrench" });
                break;
            default:
                return React.createElement("i", { className: "fa-light fa-square-question" });
        }
    }, []);
    const rightSideIcon = useMemo(() => {
        if (params.highlightStatus)
            return assigneeIcon(params.visit.assignee, 16);
        return React.createElement(StatusIcon, { status: params.visit.status });
    }, [params.visit.assignee, params.visit.status, params.highlightStatus]);
    return (React.createElement("div", { className: `cal__event ${params.highlightStatus ? '--status' : ''} ${detailed ? '--detailed' : ''}`, style: dynamicStyle },
        React.createElement("div", { className: "event__crux" },
            React.createElement("span", { className: "event__type" }, typeIcon),
            React.createElement("span", { className: "event__time" }, params.visit.start.format('hh:mm A'))),
        React.createElement("div", { className: "event__title" }, 'title' in params.visit ? params.visit.title : (_a = params.visit.building) === null || _a === void 0 ? void 0 : _a.name),
        React.createElement("div", { className: "event__indicate" }, rightSideIcon),
        detailed && params.visit.description && React.createElement("div", { className: "event__details" }, params.visit.description)));
}
function StatusIcon({ status }) {
    return (React.createElement("span", { className: "qmb-status", style: { color: status.color } },
        React.createElement("i", { className: status.icon })));
}
export default React.memo(Visit);
